module.exports = __webpack_public_path__ + "img/porte-entree.ccacc26.svg";